import { Expose, Type } from 'class-transformer';
import { Address, HonorificPrefix } from './customer';

export class CreateCustomer {
  email: string;
  givenName: string;
  familyName: string;
  phoneNumber: string;
  dateOfBirth?: string;
  honorificPrefix?: HonorificPrefix;
  @Expose({ name: 'rawAddress', toPlainOnly: true })
  @Type(() => Address)
  address?: Address;
  marketingChannels?: MarketingChannel[];
}

export class MarketingChannel {
  channel: string;
  optIn: boolean;
  submitted: string;
  privacyPolicyVersionId: string;
  marketingChannelVersionId: string;
}
